import { STEPS } from "../../../../enums/ateliers"
import { BotParams } from "./interfaces"

export const BOT_PARAMS_DEFAULT_VALUES: BotParams = {
  step: STEPS.PRESENTATION,
}
